import { ShieldAlertIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@/shared/components/empty-state/EmptyState';

import { useAdminRestricted, useHasAnyPermission } from './hooks';

/**
 * Renders children for people who hold one of the permissions (administrators always do); everyone else sees the same "no
 * access" state as `AdminOnly`. `scoped`: somebody limited to departments passes too (the server checks each target). Pages
 * guard themselves with it and call their queries below it, so a direct URL fires no request the server would refuse.
 */
export function RequirePermission({
  any,
  scoped = false,
  children,
}: {
  any: readonly string[];
  scoped?: boolean;
  children: ReactNode;
}) {
  const { t } = useTranslation('shared');
  const allowed = useHasAnyPermission(any, { scoped });
  const restricted = useAdminRestricted();
  if (!allowed) {
    return (
      <div data-testid="forbidden-state">
        <EmptyState
          icon={ShieldAlertIcon}
          size="lg"
          title={t('errors.forbiddenTitle')}
          description={restricted ? t('errors.adminNetwork') : t('errors.forbidden')}
        />
      </div>
    );
  }
  return children;
}
